import { ButtonBase } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardChip } from "../../../../../../shared/components/badges/StandardChip"
import type { StandardChipVariantType } from "../../../../../../shared/components/badges/StandardChip"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { ID_CARD_STATUS_L10N_BASE } from "../idCardsListHelpers"
import { IdCardStatus } from "../idCardsListTypes"

const useStyles = makeStyles()(() => ({
    button: {
        borderRadius: "1rem",
    },
    chip: {
        cursor: "pointer",
    },
}))

const STATUS_CHIP_VARIANTS: Readonly<Record<IdCardStatus, StandardChipVariantType>> = {
    [IdCardStatus.ASSIGNED]: "success",
    [IdCardStatus.UNASSIGNED]: "info",
    [IdCardStatus.EXPIRED]: "yellow",
    [IdCardStatus.INACTIVE]: "red",
}

type IdCardStatusChipProps = Readonly<{
    status: IdCardStatus
    onClick: (status: IdCardStatus) => void
}>

export function IdCardStatusChip({ status, onClick }: IdCardStatusChipProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="merchant-id-cards-list-status-chip-button" attrs={{ title: true }}>
            <ButtonBase className={classes.button} title="" onClick={() => onClick(status)}>
                <LocalizedEnum base={ID_CARD_STATUS_L10N_BASE} enumValue={status}>
                    <StandardChip variant={STATUS_CHIP_VARIANTS[status]} placement="table" className={classes.chip}>
                        {status}
                    </StandardChip>
                </LocalizedEnum>
            </ButtonBase>
        </LocalizedStrict>
    )
}
